
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.footer-wrapper {
  width: 100%;
  background-color: var(--primary-blue);
  color: var(--neutral-white)
}
.footer {
  padding-top: 3rem;
  padding-bottom: 3rem
}
@media (min-width: 1024px) {
  .footer {
    padding-left: 2rem;
    padding-right: 2rem
  }
}
@media (min-width: 1024px) {
  .footer .footer-top-supersection {
    display: flex
  }
}
.footer .footer-logo-section {
  padding-left: 1.5rem;
  padding-right: 1.5rem
}
.footer .footer-logo-section {
  text-align: center
}
.footer .footer-logo-section {
  font-family: var(--ff-body)
}
.footer .footer-logo-section {
  font-size: var(--fs-lg);
  line-height: var(--lh-lg)
}
@media (min-width: 1024px) {
  .footer .footer-logo-section {
    flex-grow: 0
  }
}
@media (min-width: 1024px) {
  .footer .footer-logo-section {
    padding-left: 0px;
    padding-right: 0px
  }
}
@media (min-width: 1024px) {
  .footer .footer-logo-section {
    text-align: left
  }
}
.footer ::slotted([slot='footer-menu-section']), .footer [slot='footer-menu-section'] {
  margin-left: 1rem;
  margin-right: 1rem
}
.footer ::slotted([slot='footer-menu-section']), .footer [slot='footer-menu-section'] {
  font-family: var(--ff-display)
}
@media (min-width: 1024px) {
  .footer ::slotted([slot='footer-menu-section']), .footer [slot='footer-menu-section'] {
    margin-left: 0px;
    margin-right: 0px
  }
}
@media (min-width: 1024px) {
  .footer ::slotted([slot='footer-menu-section']), .footer [slot='footer-menu-section'] {
    margin-left: 4rem
  }
}
@media (min-width: 1024px) {
  .footer ::slotted([slot='footer-menu-section']), .footer [slot='footer-menu-section'] {
    display: grid
  }
}
@media (min-width: 1024px) {
  .footer ::slotted([slot='footer-menu-section']), .footer [slot='footer-menu-section'] {
    flex-grow: 1
  }
}
@media (min-width: 1024px) {
  .footer ::slotted([slot='footer-menu-section']), .footer [slot='footer-menu-section'] {
    grid-template-columns: repeat(3, minmax(0, 1fr))
  }
}
@media (min-width: 1024px) {
  .footer ::slotted([slot='footer-menu-section']), .footer [slot='footer-menu-section'] {
    gap: 2.5rem
  }
}
@media (min-width: 1280px) {
  .footer ::slotted([slot='footer-menu-section']), .footer [slot='footer-menu-section'] {
    margin-left: 9rem
  }
}
@media (min-width: 1360px) {
  .footer ::slotted([slot='footer-menu-section']), .footer [slot='footer-menu-section'] {
    margin-left: 12rem
  }
}
.footer .footer-disclaimer-et-al-section {
  padding-left: 1rem;
  padding-right: 1rem
}
.footer .footer-disclaimer-et-al-section {
  text-align: center
}
@media (min-width: 1024px) {
  .footer .footer-disclaimer-et-al-section {
    display: flex
  }
}
@media (min-width: 1024px) {
  .footer .footer-disclaimer-et-al-section {
    justify-content: space-between
  }
}
@media (min-width: 1024px) {
  .footer .footer-disclaimer-et-al-section {
    padding-left: 0px;
    padding-right: 0px
  }
}
.footer .footer-links {
  margin-bottom: 1rem
}
.footer .footer-links {
  width: 100%
}
.footer .footer-links {
  font-family: var(--ff-display)
}
.footer .footer-brand-logo {
  margin-left: auto;
  margin-right: auto
}
.footer .footer-brand-logo {
  max-width: 140px
}
.footer .footer-brand-logo {
  padding-bottom: 1.75rem
}
.footer .footer-brand-logo {
  font-size: var(--fs-2xl);
  line-height: var(--lh-2xl)
}
@media (min-width: 1024px) {
  .footer .footer-brand-logo {
    margin-left: 0px;
    margin-right: 0px
  }
}
@media (min-width: 1024px) {
  .footer .footer-brand-logo {
    max-width: 200px
  }
}
.footer .footer-contact {
  padding-bottom: 0.625rem
}
.footer .footer-social-icons {
  padding-bottom: 1.5rem
}
.footer .footer-great-divide-hr {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem
}
.footer .footer-great-divide-hr {
  height: 1px
}
.footer .footer-great-divide-hr {
  border-style: none
}
.footer .footer-great-divide-hr {
  background-color: var(--primary-blue-dark)
}
.footer .footer-privacy-policy, .footer .footer-terms-of-use, .footer .footer-contact-us {
  margin-left: auto;
  margin-right: auto
}
.footer .footer-privacy-policy, .footer .footer-terms-of-use, .footer .footer-contact-us {
  margin-bottom: 1.5rem
}
.footer .footer-privacy-policy, .footer .footer-terms-of-use, .footer .footer-contact-us {
  font-family: var(--ff-display)
}
.footer .footer-privacy-policy, .footer .footer-terms-of-use, .footer .footer-contact-us {
  font-size: var(--fs-sm);
  line-height: var(--lh-sm)
}
.footer .footer-copyright {
  margin-bottom: 2rem
}
.footer .footer-copyright {
  font-family: var(--ff-body)
}
@media (min-width: 1024px) {
  .footer .footer-copyright {
    text-align: left
  }
}
.footer .footer-btt {
  width: 100%
}
.footer .footer-btt {
  font-family: var(--ff-display)
}
@media (min-width: 1024px) {
  .footer .footer-btt {
    width: 31%
  }
}
@media (min-width: 1024px) {
  .footer .footer-btt {
    text-align: right
  }
}
@media (min-width: 1280px) {
  .footer .footer-btt {
    width: 20%
  }
}
.footer-subsection {
  display: block
}
.footer-subsection-hr {
  margin-top: 0px;
  margin-bottom: 1rem;
  height: 0.125rem;
  border-style: none;
  background-color: var(--tertiary-sky-blue)
}
.footer-subsection-title {
  margin-bottom: 1.25rem;
  font-size: var(--fs-xl);
  line-height: var(--lh-xl);
  font-weight: var(--fw-bold);
  color: var(--neutral-white)
}
.footer-subsection-slots ul {
  margin: 0px
}
.footer-subsection-slots ul {
  margin-bottom: 2rem
}
.footer-subsection-slots ul {
  list-style-type: none
}
.footer-subsection-slots ul {
  padding: 0px
}
.footer-subsection-slots ul {
  text-align: left
}
.footer-subsection-slots ul {
  color: var(--neutral-white)
}
.footer-subsection-slots ul li {
  margin-left: 0px;
  margin-right: 0px
}
.footer-subsection-slots ul li {
  margin-bottom: 0.875rem
}
.footer-subsection-slots a {
  color: var(--neutral-white)
}
.footer-subsection-slots a {
  text-decoration-line: none
}
.footer-subsection-slots a:hover {
  text-decoration-line: underline
}
:host([site='BH']) .footer-subsection-hr {
  display: none
}
:host([site='BH']) .footer-subsection-title {
  font-family: var(--bh-ff-display)
}
:host([site='BH']) .footer-subsection-title {
  font-size: var(--bh-fs-heading-04);
  line-height: var(--bh-lh-heading-04);
  letter-spacing: var(--bh-ls-heading-04)
}
:host([site='BH']) .footer-subsection-title {
  font-weight: var(--fw-normal)
}
:host([site='BH']) .footer-subsection-slots a {
  font-size: var(--bh-fs-body-01);
  line-height: var(--bh-lh-body-01);
  letter-spacing: var(--bh-ls-body-01)
}
.static-container {
  margin-left: auto;
  margin-right: auto;
  display: block;
  max-width: 100vw;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  font-family: var(--ff-body)
}
.static-container.header {
  display: flex;
  flex-direction: column
}
@media (min-width: 1024px) {
  .static-container.header {
    flex-direction: row
  }
}
@media (min-width: 640px){
  .static-container {
    max-width: 640px
  }
}
@media (min-width: 768px){
  .static-container {
    max-width: 768px
  }
}
@media (min-width: 1024px){
  .static-container {
    max-width: 1024px
  }
}
@media (min-width: 1280px){
  .static-container {
    max-width: 1280px
  }
}
@media (min-width: 1360px){
  .static-container {
    max-width: 1360px
  }
}
@media (min-width: 2180px){
  .static-container {
    max-width: 2180px
  }
}
`;